import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Modals.scss';

function ModalTitle({ type, children }) {
    return (<span className={styles[`modal-title-${type}`]}>
        {children}
    </span>)
}

ModalTitle.displayName = displayName('Modals/ModalTitle');

ModalTitle.modalTypes = [
    'normal',
    'report-summary',
    'report-collection',
    'warning',
    'delete',
    'csv',
    'csv-error',
    'alert',
    'users-disable',
    'users-enable',
    'summary',
];

ModalTitle.propTypes = {
    type: PropTypes.oneOf(ModalTitle.modalTypes),
    children: PropTypes.node.isRequired,
};

ModalTitle.defaultProps = {
    type: 'normal',
};
export default ModalTitle;
